import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import "@/App.css";

import Nav from "./components/Nav";
import Hero from "./components/Hero";
import Marquee from "./components/Marquee";
import UpcomingRelease from "./components/UpcomingRelease";
import LatestRelease from "./components/LatestRelease";
import Merch from "./components/Merch";
import Gallery from "./components/Gallery";
import Tour from "./components/Tour";
import Newsletter from "./components/Newsletter";
import Contact from "./components/Contact";
import Footer from "./components/Footer";

const MARQUEE_ITEMS = [
  "Only You — out now",
  "Pre-save Be Alright",
  "New single · June 22, 2026",
  "Stream on Spotify, Apple Music & YouTube",
];

function HomePage() {
  return (
    <div data-testid="home-page" className="relative bg-white text-[#0A0A0A] min-h-screen">
      <div className="film-grain" aria-hidden />
      <Nav />
      <main>
        <Hero />
        <div data-testid="marquee-strip" className="border-y border-[#E6EAEF] bg-white py-4 text-[#0A0A0A]">
          <Marquee items={MARQUEE_ITEMS} />
        </div>
        <UpcomingRelease />
        <LatestRelease />
        <Merch />
        <Gallery />
        <Tour />
        <Newsletter />
        <Contact />
      </main>
      <Footer />
    </div>
  );
}

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Toaster
          theme="light"
          position="bottom-right"
          toastOptions={{
            style: {
              background: "#FFFFFF",
              border: "1px solid #E6EAEF",
              color: "#0A0A0A",
              fontFamily: "'Outfit', sans-serif",
              boxShadow: "0 12px 32px rgba(10,10,10,0.06)",
            },
          }}
        />
        <Routes>
          <Route path="/" element={<HomePage />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
